import axios from 'axios/index';
import baseURL from '../constants/server';
import baseURLGrass from '../constants/serverGrass';

export const tokenStorageKey = 'gravy_token';
export const fcmTokenStorageKey = 'fcmToken';

/**
*
* @type {AxiosInstance}
*/
export const httpClient = axios.create({
  baseURL,
  headers: {
    common: {
      'Content-Type': 'application/json',
      'Authorization': getSavedAuthToken()
    }
  }
});

export const httpClientGrass = axios.create({
  baseURL: baseURLGrass,
  headers: {
    common: {
      'Content-Type': 'application/json',
      'Authorization': getSavedAuthToken()
    }
  }
});

export function setAuthToken (token) {
  httpClient.defaults.headers.common['Authorization'] = token;
  httpClientGrass.defaults.headers.common['Authorization'] = token;
  return saveAuthToken(token);
}

export function saveAuthToken (token) {
  window.localStorage.setItem(tokenStorageKey, token);
}

export function getSavedAuthToken () {
  return window.localStorage.getItem(tokenStorageKey);
}

export function removeAuthToken () {
  window.localStorage.removeItem(tokenStorageKey);
}



// WEBPACK FOOTER //
// ./src/api/httpClient.js